import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaSearch, FaStar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

// Extended trainer data with more trainers
const trainersData = [
  {
    id: 1,
    name: "Jack Drake",
    title: "Senior Trainer",
    image: "/src/images/trainer1.png",
    rating: 4.9,
    experience: "8 Years",
    specialties: ["Weight Loss", "Strength Training", "Muscle Building"],
    certifications: ["NASM-CPT", "Nutrition Specialist", "Advanced Personal Training"]
  },
  {
    id: 2,
    name: "Nathaniel",
    title: "Fitness Coach",
    image: "/src/images/trainer2.png",
    rating: 4.8,
    experience: "6 Years",
    specialties: ["CrossFit", "HIIT", "Athletic Performance"],
    certifications: ["CrossFit Level 2", "ACSM-CPT", "Sports Performance Coach"]
  },
  {
    id: 3,
    name: "Sarah Johnson",
    title: "Yoga & Wellness Instructor",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&h=400",
    rating: 4.9,
    experience: "10 Years",
    specialties: ["Yoga", "Meditation", "Flexibility Training"],
    certifications: ["Yoga Alliance RYT-500", "Meditation Teacher", "Wellness Coach"]
  },
  {
    id: 4,
    name: "Marcus Rodriguez",
    title: "Strength & Conditioning Coach",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=400&fit=crop&crop=face",
    rating: 4.8,
    experience: "12 Years",
    specialties: ["Powerlifting", "Olympic Lifting", "Competition Prep"],
    certifications: ["NSCA-CSCS", "Olympic Lifting Coach", "Powerlifting Certified"]
  },
  {
    id: 5,
    name: "Emily Chen",
    title: "Rehabilitation Specialist",
    image: "https://images.unsplash.com/photo-1594736797933-d0f71380ce8e?w=400&h=400&fit=crop&crop=face",
    rating: 4.7,
    experience: "9 Years",
    specialties: ["Pilates", "Physical Therapy", "Injury Recovery"],
    certifications: ["DPT", "Pilates Instructor", "Corrective Exercise Specialist"]
  },
  {
    id: 6,
    name: "David Thompson",
    title: "Bodybuilding Coach",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
    rating: 4.9,
    experience: "15 Years",
    specialties: ["Bodybuilding", "Nutrition", "Contest Prep"],
    certifications: ["IFBB Pro Card", "Nutrition Coach", "Posing Coach"]
  },
  {
    id: 7,
    name: "Jessica Wong",
    title: "Group Fitness Instructor",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face",
    rating: 4.6,
    experience: "7 Years",
    specialties: ["Zumba", "Dance Fitness", "Group Classes"],
    certifications: ["ACE Group Fitness", "Zumba Instructor", "Dance Certified"]
  },
  {
    id: 8,
    name: "Michael Brooks",
    title: "Functional Training Expert",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
    rating: 4.8,
    experience: "10 Years",
    specialties: ["Functional Training", "Mobility", "Movement Patterns"],
    certifications: ["FMS Certified", "NASM-CES", "Mobility Specialist"]
  },
  {
    id: 9,
    name: "Amanda Rodriguez",
    title: "Nutrition & Wellness Coach",
    image: "https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=400&h=400&fit=crop&crop=face",
    rating: 4.9,
    experience: "11 Years",
    specialties: ["Nutrition Coaching", "Weight Management", "Meal Planning"],
    certifications: ["RD", "Precision Nutrition", "Wellness Coach"]
  },
  {
    id: 10,
    name: "Ryan Parker",
    title: "Combat Sports Trainer",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face",
    rating: 4.7,
    experience: "13 Years",
    specialties: ["Boxing", "MMA", "Self Defense"],
    certifications: ["Boxing Coach License", "MMA Instructor", "Krav Maga"]
  },
  {
    id: 11,
    name: "Lisa Thompson",
    title: "Senior Fitness Consultant",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=400&fit=crop&crop=face",
    rating: 4.8,
    experience: "14 Years",
    specialties: ["Personal Training", "Fitness Assessment", "Program Design"],
    certifications: ["NASM-CPT", "FMS Level 2", "Fitness Consultant"]
  },
  {
    id: 12,
    name: "Carlos Mendoza",
    title: "Cardio & Endurance Specialist",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
    rating: 4.7,
    experience: "8 Years",
    specialties: ["Marathon Training", "Cardio Conditioning", "Endurance"],
    certifications: ["RRCA Certified", "Endurance Coach", "Running Specialist"]
  },
  {
    id: 13,
    name: "Sophie Martinez",
    title: "Women's Fitness Specialist",
    image: "https://images.unsplash.com/photo-1594736797933-d0f71380ce8e?w=400&h=400&fit=crop&crop=face",
    rating: 4.9,
    experience: "9 Years",
    specialties: ["Women's Training", "Pre/Post Natal", "Hormonal Health"],
    certifications: ["NASM-WFS", "Pre/Post Natal Specialist", "Women's Health"]
  },
  {
    id: 14,
    name: "James Wilson",
    title: "Senior Strength Coach",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
    rating: 4.8,
    experience: "16 Years",
    specialties: ["Strength Training", "Powerlifting", "Athletic Development"],
    certifications: ["NSCA-CSCS", "USAPL Coach", "Strength Specialist"]
  },
  {
    id: 15,
    name: "Rachel Kim",
    title: "Mind-Body Wellness Coach",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face",
    rating: 4.8,
    experience: "7 Years",
    specialties: ["Tai Chi", "Qigong", "Stress Management"],
    certifications: ["Tai Chi Instructor", "Qigong Master", "Stress Management"]
  }
];

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
`;

const MainContent = styled.div`
  padding: 100px 20px 60px;
  max-width: 1400px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 80px 15px 40px;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;
  
  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

const Title = styled.h1`
  font-size: 3.5rem;
  color: #fff;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #ccc;
  margin-bottom: 40px;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  max-width: 500px;
  margin: 0 auto;
`;

const SearchInput = styled.input`
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(57, 211, 83, 0.3);
  border-radius: 25px;
  padding: 15px 50px 15px 20px;
  color: #fff;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
  
  &::placeholder {
    color: #ccc;
  }
  
  &:focus {
    outline: none;
    border-color: #39d353;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 0 0 3px rgba(57, 211, 83, 0.1);
  }
  
  &:hover {
    border-color: rgba(57, 211, 83, 0.5);
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #39d353;
  font-size: 1.1rem;
  pointer-events: none;
`;

const StatsSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 60px;
  margin: 60px 0;
  padding: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    text-align: center;
    margin: 40px 0;
    padding: 30px 20px;
  }
`;

const StatItem = styled.div`
  text-align: center;
`;

const StatNumber = styled.div`
  font-size: 3rem;
  font-weight: bold;
  color: #39d353;
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const StatLabel = styled.div`
  font-size: 1.1rem;
  color: #ccc;
  font-weight: 500;
`;

const TrainersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 2.5rem;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const TrainerCard = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease;
  position: relative;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
    background: rgba(255, 255, 255, 0.12);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #39d353, #4ade80);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover::before {
    opacity: 1;
  }
  
  @media (max-width: 768px) {
    border-radius: 15px;
    
    &:hover {
      transform: translateY(-5px);
    }
  }
`;

const TrainerImage = styled.div`
  width: 100%;
  height: 200px;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  }
  
  @media (max-width: 768px) {
    height: 140px;
    
    &::after {
      height: 40px;
    }
  }
`;

const RatingBadge = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.8);
  color: #39d353;
  padding: 8px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  font-weight: bold;
  backdrop-filter: blur(10px);
`;

const CardContent = styled.div`
  padding: 25px;
  
  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const TrainerInfo = styled.div`
  margin-bottom: 20px;
`;

const TrainerName = styled.h3`
  font-size: 1.4rem;
  color: #fff;
  margin: 0 0 8px 0;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin: 0 0 5px 0;
  }
`;

const TrainerTitle = styled.p`
  color: #39d353;
  margin: 0 0 8px 0;
  font-size: 1rem;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 0.85rem;
    margin: 0 0 5px 0;
  }
`;

const Experience = styled.p`
  color: #ccc;
  margin: 0;
  font-size: 0.9rem;
  font-weight: 400;
`;

const Section = styled.div`
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

const SectionTitle = styled.h4`
  color: #fff;
  font-size: 1rem;
  margin: 0 0 12px 0;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin: 0 0 8px 0;
  }
`;

const SpecialtiesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 15px;
`;

const SpecialtyTag = styled.span`
  background: rgba(57, 211, 83, 0.2);
  color: #39d353;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid rgba(57, 211, 83, 0.3);
  
  @media (max-width: 768px) {
    padding: 4px 8px;
    font-size: 0.7rem;
    border-radius: 12px;
  }
`;

const CertificationsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Certification = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ccc;
  font-size: 0.85rem;
  
  &::before {
    content: '✓';
    color: #39d353;
    font-weight: bold;
    font-size: 1rem;
  }
  
  @media (max-width: 768px) {
    font-size: 0.75rem;
    gap: 8px;
    
    &::before {
      font-size: 0.9rem;
    }
  }
`;

function AllTrainersFullPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const navigate = useNavigate();

  // Navigation functions for navbar
  const scrollToAbout = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('[data-section="services"]');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const scrollToTrainers = () => {
    // Already on trainers page, scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToShop = () => {
    navigate('/shop');
  };

  const scrollToTrainingZone = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('[data-section="training-zone"]');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('[data-section="contact"]');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Filter trainers based on search term
  const filteredTrainers = trainersData.filter(trainer =>
    trainer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    trainer.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    trainer.specialties.some(specialty =>
      specialty.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <PageContainer>
      <Navbar
        scrollToTrainers={scrollToTrainers}
        scrollToAbout={scrollToAbout}
        scrollToShop={scrollToShop}
        scrollToTrainingZone={scrollToTrainingZone}
        scrollToContact={scrollToContact}
      />

      <MainContent>
        <Header>
          <Title>Our Expert <span style={{ color: '#39d353' }}>Trainers</span></Title>
          <Subtitle>
            Meet our certified professionals who are dedicated to helping you achieve your fitness goals.
            With years of experience and specialized knowledge, they're here to guide you every step of the way.
          </Subtitle>

          <SearchContainer>
            <SearchInput
              type="text"
              placeholder="Search trainers by name, specialty, or certification..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchIcon>
              <FaSearch />
            </SearchIcon>
          </SearchContainer>
        </Header>

        <StatsSection>
          <StatItem>
            <StatNumber>{trainersData.length}</StatNumber>
            <StatLabel>Expert Trainers</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>150+</StatNumber>
            <StatLabel>Certifications</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>12</StatNumber>
            <StatLabel>Years Average Experience</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>5000+</StatNumber>
            <StatLabel>Clients Trained</StatLabel>
          </StatItem>
        </StatsSection>

        <TrainersGrid>
          {filteredTrainers.map((trainer) => (
            <TrainerCard key={trainer.id}>
              <TrainerImage src={trainer.image}>
                <RatingBadge>
                  <FaStar />
                  {trainer.rating}
                </RatingBadge>
              </TrainerImage>

              <CardContent>
                <TrainerInfo>
                  <TrainerName>{trainer.name}</TrainerName>
                  <TrainerTitle>{trainer.title}</TrainerTitle>
                  <Experience>{trainer.experience} Experience</Experience>
                </TrainerInfo>

                <Section>
                  <SectionTitle>Specialties</SectionTitle>
                  <SpecialtiesList>
                    {trainer.specialties.map((specialty, index) => (
                      <SpecialtyTag key={index}>
                        {specialty}
                      </SpecialtyTag>
                    ))}
                  </SpecialtiesList>
                </Section>

                <Section>
                  <SectionTitle>Certifications</SectionTitle>
                  <CertificationsList>
                    {trainer.certifications.map((cert, index) => (
                      <Certification key={index}>
                        {cert}
                      </Certification>
                    ))}
                  </CertificationsList>
                </Section>
              </CardContent>
            </TrainerCard>
          ))}
        </TrainersGrid>

        {filteredTrainers.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            color: '#ccc',
            fontSize: '1.2rem'
          }}>
            No trainers found matching your search criteria.
          </div>
        )}
      </MainContent>

      <Footer />
    </PageContainer>
  );
}

export default AllTrainersFullPage;